<mat-card *ngIf="isVisible()" class="shadow-none bg-light-{{ type() }} overflow-hidden mt-2">
  <div class="p-0 p-l-14 p-r-14">
    <div class="row justify-content-between">
      <div class="col-sm-8">
        <mat-card-subtitle class="mat-mdc-card-subtitle mat-body-1 text-{{ type() }} m-t-12 lh-24 m-b-20">
          <h3> {{ title() | translate }}</h3>
          <p>{{ messageContent() | translate }}</p>
        </mat-card-subtitle>
      </div>
      <div class="col-sm-4 text-right d-flex justify-content-end align-items-center">
        <tabler-icon name="{{icon()}}" class="icon-message text-{{ type() }}"></tabler-icon>
      </div>
    </div>
  </div>
</mat-card>
